import React, { createContext, useContext, useEffect, useState, ReactNode } from "react";
import {DialogRecord} from "@/Master/SDialogFC/SDialogManagerFC";


export interface DialogContextType {
    dialogs: DialogRecord[];
    openDialog: (key:string) => void;
    closeDialog: (key:string) => void;
}

export const DialogContext = createContext<DialogContextType | null>(null);



